import styled from "styled-components";
import { fonts } from "theme/fonts";

export const ButtonPrimary = ({
  as,
  href,
  className,
  onClick,
  target,
  rel,
  children,
}) => {
  return (
    <Wrapper
      as={as}
      href={href}
      className={className}
      onClick={onClick}
      target={target}
      rel={rel}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.button`
  width: 100%;
  /* padding-bottom: 9px;
  padding-top: 13px; */
  border: 0px;
  background-color: #ffbc0d;
  color: #000;
  font-size: 1.2rem;
  font-weight: 500;
  outline: 0;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  font-family: "Speedee_Reg";

  &:hover {
  }
`;
